<template>
    <div class="card widget widget-products" v-if="products.length > 0">
        <div class="widget__header">
            <h4>Alternate Products</h4>
        </div>
        <div class="widget-products__list">
            <alternate-product-item
                v-for="(product, indx) in products"
                :key="product.ID"
                :index="indx"
                :productDetails="product"
            >
            </alternate-product-item>
        </div>
    </div>
</template>

<script>

import AlternateProductItem from './AlternateProductItem.vue';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
// import Cloudinary from '../../../utilities/cloudinary';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";
// import {scale} from "@cloudinary/base/actions/resize";

export default {
    components: { AlternateProductItem },

    data() {
        return {
            products : [],
        };
    },

    props: {
        manufacturer: {
            type: String,
            required: true
        },
        partnumber: {
            type: String,
            required: true,
        },
    },

    computed: {
        // latest_products() {
        //     return this.$store.getters['product/latest'];
        // }
    },

    methods: {
        getProductDetails(itemsku, manufacturer, image){
            // console.log(image);
            axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": manufacturer },
                        "EIITMC": { "value": itemsku },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {

                    const linetotal = 1 * fields.EIEXCP.value;
                    const defaultLoc = this.$store.getters.getCustomerDetails;
                    const clearProductDesc = encodeURIComponent(fields.IMDESC.value);

                    this.prod = {
                        ID: fields.IMITMC.value,
                        IMITMC: fields.IMITMC.value,
                        item: fields.IMITMC.value,
                        desc: fields.IMDESC.value,
                        manufacturer: fields.IMMFGC.value,
                        image: image,
                        quantity: this.requestedQuantity,
                        corecharge: fields.EICORP.value,
                        yourprice: fields.EIEXCP.value,
                        listprice: fields.EILSTP.value,
                        shipping: 0,
                        linetotal: linetotal,
                        stockquantity: fields.QTYAVL.value,
                        MCNAME        : fields.MCNAME.value,
                        mfgSeo        : fields.MCNAME.value.replace(/ /g, "-"),
                        itemSeo       : clearProductDesc.replace(/ /g, "-"),

                        locationid: fields.CMDLOC.value,
                        locationname: defaultLoc.defaultlocationname,
                        locationcity: defaultLoc.defaultlocationcity,
                        locationstate: defaultLoc.defaultlocationstate,
                    };

                    this.latest_products.push(this.prod);
                }else{
                    this.isloading = false;
                }
            })
            .catch((error) => {
                console.log("error - " + error);
            });
        },

        getSubstitutes(){
            this.isloading = true;
            axiosvl.post(this.$store.getters['api/substitute_parts_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "EIMFGC": { "value": this.manufacturer },
                        "EIITMC": { "value": this.partnumber },
                    },   
                }
            })
            .then((response) => {
                const CPARTS = response.data.webroutine.lists.CPARTS.entries;
                const wd_mdfgs = this.$store.getters.wd_mfgs;
                this.products = [];
                for (const key in CPARTS) {
                    const obj = CPARTS[key];
                    const clApi = new CloudinaryApi;
                    const clearProductDesc = encodeURIComponent(obj.IMDESC);
                    clApi.item_sku = obj.DMITMC;
                    clApi.manufacturer_code = obj.IUUMFG;
                    
                    clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                        let image;
                        if(imgURL){
                            image = imgURL;
                        }else{
                            image = GCONST.IMAGE_PLACEHOLDER;
                        }

                        this.products.push({
                            ID            : obj.DMITMC,
                            IMITMC        : obj.DMITMC,
                            item          : obj.IMDESC,
                            desc          : obj.IMDESC,
                            quantity      : 1,
                            image         : image,
                            isSelected    : false,
                            avail_locs    : null,
                            MCNAME        : wd_mdfgs.find(w => w.MFG_CODE == obj.IUUMFG).MFG_DESC,

                            mfgSeo        : wd_mdfgs.find(w => w.MFG_CODE == obj.IUUMFG).SEO,
                            itemSeo       : clearProductDesc.replace(/ /g, "-"),

                            manufacturer    : obj.IUUMFG,
                            listprice       : obj.EILSTP,
                            corecharge      : obj.CORP,
                            yourprice       : obj.PRC,
                            
                            XRMFGC          : obj.XRMFGC,
                            XRITMC          : obj.XRITMC,
                            IMIGSA          : obj.IMIGSA,
                            IMISVALID       : obj.IMISVALID,
                        });

                        if (this.customerIndicator == 'B'){
                            setTimeout(() => {
                                this.isloading = true;
                                this.stockCheck(obj.IUUMFG, obj.DMITMC).then(res => {
                                    this.prodLocs.push({
                                        ITEM: obj.DMITMC,
                                        MFGC: obj.IUUMFG,
                                        locations: res
                                    })
                                    // this.products[i].avail_locs = res;
                                    this.isloading = false;
                                });
                            }, 500);
                        }else{
                            this.isloading = false;
                        }
                        
                    });
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

    },
    created() {
        // this.getSubstitutes();
    }
    
}
</script>